import { render, staticRenderFns } from "./editar-empresa.vue?vue&type=template&id=1bbd6cca&scoped=true&"
import script from "./editar-empresa.vue?vue&type=script&lang=js&"
export * from "./editar-empresa.vue?vue&type=script&lang=js&"
import style0 from "./editar-empresa.vue?vue&type=style&index=0&id=1bbd6cca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd6cca",
  null
  
)

export default component.exports